import React from "react";

const BookMark = () => {
  return <div>BookMark</div>;
};

export default BookMark;
